import store from '@/store/index'

/**
 * dict的元数据定义
 * @type {{metas: {"*": {request(*): *, valueField: string, dictType: null, labelField: string}}}}
 */
export const options = {

  // 元数据定义
  // metas:{'*':{}, 'prod_state':{}}，采用这种定义，便于定义扩展，
  // '*'表示默认dictType的定义，如果有特殊可以单独定义，在Dict.parse里面会根据dictType取出
  // 特殊定义：metas:{'prod_state':{dictType: sys_yes_no, labelField, valueField, request}, xx}
  metas: {
    '*': {
      dictType: null,
      dataType: Number, // 值类型
      exclude: null, // 排除的value的选项
      isTree: false,    // 是否是树形字典
      treeLevel: null,  // 是树形字典时候，获取节点级别
      valueField: 'dictValue',
      labelField: 'dictLabel',
      cache: true,
      requestGroup: null,
      request: null,
      // 字典数据转换器，方法为function(dictMeta: DictMeta, response: Object): Object
      fieldNameConverter: null,
    },
  },

  requestDictBatch(dictMetas) {
    // console.log('=====>加载数据字典：', JSON.stringify(dictMetas));
    if (dictMetas && dictMetas.length > 0) {
      // 分组自定义request和默认自定request
      let defaultReqDictMetas = [];
      let customReqDictMetas = {};
      dictMetas.forEach(dictMeta => {
        if(!dictMeta.requestGroup) {
          defaultReqDictMetas.push(dictMeta);
        } else {
          // console.log('=====>加载数据字典：', dictMeta.requestGroup);
          let arr = customReqDictMetas[dictMeta.requestGroup];
          if(arr) {
            customReqDictMetas[dictMeta.requestGroup].push(dictMeta);
          } else {
            customReqDictMetas[dictMeta.requestGroup] = [dictMeta];
          }
        }
      });
      // console.log('=====>批量加载数据字典：', defaultReqDictMetas);
      if(defaultReqDictMetas.length > 0) {
        store.dispatch('doSelectDictBatch', defaultReqDictMetas).then(data => data);
      }
      console.log('=====>加载自定义字典：', customReqDictMetas);
      if(Object.keys(customReqDictMetas).length > 0) {
        store.dispatch('doSelectDictCustomBatch', customReqDictMetas).then(data => data);
      }
    }
  },
  requestDictTreeBatch(dictTreeMetas) {
    if (dictTreeMetas && dictTreeMetas.length > 0) {
      console.log('批量加载树结构数据字典：', dictTreeMetas);
      return store.dispatch('doSelectDictTreeBatch', dictTreeMetas).then(data => data);
    }
    return null;
  },
}

export default options
